<template>
    <div class="assess-all">

        <van-list class="list-height" :loading="loading" :finished="finished" :immediate-check="false" :offset="100"
                  finished-text="没有更多了" @load="chengeLoad">

            <div class="chioce-box">
                <div class="chioce-nei" :style="{ 'height': isBoxHeight ? '' : 'auto' }">
                    <div class="top-box">
                        <div style="display: flex;">
                            <div :class="nLabel == index ? 'label-css' : 'label-item'"
                                 v-for="(item, index) in arrAllLabel" :key="index" @click="changeTaber(index)"
                                 v-if="item.num != 0">
                                <img :src="require('@/assets/images/project/img-icon.png')" v-if="index == 1"
                                     style="margin-right: 0px;"/>
                                {{ item.title }}<span>({{ item.num }})</span>
                            </div>
                        </div>
                        <div style="margin-top: 2px;" @click="changeSort">
                            <div class="sort-css" v-if="nSort"><span>默认</span><img
                                :src="require('@/assets/images/project/def-sort.png')"/></div>
                            <div class="sort-css" v-else><span>时间</span><img
                                :src="require('@/assets/images/project/time-sort.png')"/></div>
                        </div>
                    </div>
                    <div class="lable-box" ref="lableHight">
                        <div :class="nTabel == index ? 'lable-index' : 'lable-item'"
                             v-for="(item, index) in arrAssLabel" :key="index" @click="antLabel(index, item.title)"
                             v-if="index < 12">
                            {{ item.title }}{{ item.num }}
                        </div>
                    </div>
                    <div v-if="isShowIcon" class="down_icon"
                         :style="{ 'position': isBoxHeight ? 'absolute' : 'relative' }"
                         @click="isBoxHeight = !isBoxHeight">
                        <img :class="isBoxHeight ? 'down' : 'top'"
                             :src="require('@/assets/images/project/down_icon1.png')"/>
                    </div>
                </div>
            </div>

            <div class="user-assess">
                <div class="assess-box" v-for="(item, index) in arrShowList" :key="index">
                    <div class="user-info">
                        <div class="user-left-box">
                            <div class="head-img" v-if="item.children[0].headimgurl"><img
                                :src="item.children[0].headimgurl  + '?x-oss-process=image/resize,m_fill,h_90'"/></div>
                            <div class="user-name">
                                <div class="current-name">
                                    <div class="name" v-if="item.children[0].nickname">{{
                                            nameHide(item.children[0].nickname)
                                        }}
                                    </div>
                                    <div v-if="acc_id == item.children[0].project_uuid" class="current">本案例用户评价</div>
                                </div>
                                <div class="time">{{ item.children[0].updated_at }}</div>
                            </div>
                        </div>
                        <div v-if="isZxy" class="user-right-box" @click="toShare(item)">
                            <img :src="require('@/assets/images/project/share-icon.png')"/>
                            <span>分享</span>
                        </div>
                    </div>
                    <div v-for="(it, ix) in item.children" :key="ix">
                        <div v-if="it.open" style="margin-bottom: 30px;">
                            <!-- <div v-if="!it.open ? ix != 0: false">
                                <div class="split-line" ></div>
                            </div> -->
                            <div class="assess-stars">
                                <div class="stars-title" v-if="it.is_completed == 3">系统施工评价</div>
                                <div class="stars-title" v-if="it.is_completed != 3 && it.is_completed != '追评'">竣工交付评价
                                </div>
                                <div class="stars-title" v-if="it.is_completed == '追评'">{{
                                        computTime(it.created_at)
                                    }}后追评
                                </div>
                                <el-stare v-if="it.score != ''" :numScore="Number(it.score)"></el-stare>
                                <div v-if="it.score != ''">{{ it.score }}分</div>
                            </div>
                            <div class="assess-content">{{ it.content }}</div>
                            <div class="assess-voice" v-if="it.voice != '' && it.voice != null"
                                 @click="handlePlay(index, ix)">
                                <div style="display: flex;">
                                    <span>{{ it.voice_time }}s</span>
                                    <div class="voice-icon">
                                        <img :src="require('@/assets/images/project/voice_blue.png')"/>
                                        <img class="icon1" :src="require('@/assets/images/project/voice_blue1.png')"/>
                                        <div :id="'meng' + index + ix" class="mengceng" style="display: none"></div>
                                    </div>
                                </div>
                                <div class="triangle-icon">
                                    <div class="triangle-one"></div>
                                </div>
                                <audio :id="'audio' + index + ix" :src="it.voice"></audio>
                            </div>
                            <div class="assess-imgae" v-if="it.pic">
                                <div v-for="(im, ic) in it.pic" :key="ic" class="assess-imgae-item">
                                    <img :src="im.pic + '?x-oss-process=image/resize,m_fill,h_90'"
                                         v-if="im.type == 'image'" @click="getShow(it.pic, ic)"></img>
                                    <img :src="im.pic + '?x-oss-process=video/snapshot,t_1000,m_fast'"
                                         v-if="im.type == 'video'" @click="getShow(it.pic, ic)"></img>
                                    <!-- <video :id="'playVideo' + index + ix + ic" :src="im.pic" v-else
                                        @click="getShow(it.pic, ic)"></video> -->
                                    <div :id="'mantle' + index + ix + ic" class="video_mantle"
                                         @click="getShow(it.pic, ic)" v-if="im.type == 'video'">
                                        <img :src="require('@/assets/images/icon_play.png')"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="item.children.length > 1">
                        <div v-if="!item.open" @click="changeMore('more', item.children, item)" class="look-more">
                            <span>看查完整评价</span><img :src="require('@/assets/images/project/down_icon_blue.png')"/>
                        </div>
                        <div v-else @click="changeMore('less', item.children, item)" class="look-more-item">
                            <span>收起评价</span><img :src="require('@/assets/images/project/down_icon_blue.png')"/>
                        </div>
                    </div>
                </div>
            </div>
        </van-list>
        <audio id="audio" :src="audioUrl" hidden></audio>
        <!-- 海报 -->
        <!--        <div class="poster" :style="{background:!sBase64?'none':'rgba(0,0,0,0.6)'}" v-if="isShowPoster">-->
        <!--            <div class="poster-content" ref="canvas" id="capture">-->
        <!--                <div class="top-title">-->
        <!--                    <div class="text">{{ objPoster.poster_title || '“很满意史密斯这次的服务，采暖、 空调效果也非常好”' }}</div>-->
        <!--                    <div class="name">—— {{ objPoster.city }}用户 {{ objPoster.name }}</div>-->
        <!--                </div>-->
        <!--                <div class="poster-bgc">-->
        <!--                    <img v-if="objPoster.poster_pic" :src="objPoster.poster_pic" alt="">-->
        <!--                    <img v-else src="@/assets/images/share/top-bgc.png" alt="">-->
        <!--                </div>-->
        <!--                <div class="title">{{ objPoster.city }} ｜ {{ objPoster.project_name2 }}</div>-->
        <!--                <div class="info">-->
        <!--                    <div class="info-item">-->
        <!--                        <img src="@/assets/images/share/rl.png" alt="">-->
        <!--                        <span>{{ objPoster.date.split(' ')[0] }}</span>-->
        <!--                    </div>-->
        <!--                    <div v-if="objPoster.house_cate" class="info-item">-->
        <!--                        <img src="@/assets/images/share/bs.png" alt="">-->
        <!--                        <span>{{ objPoster.house_cate }}</span>-->
        <!--                    </div>-->
        <!--                    <div v-if="objPoster.house_area" class="info-item">-->
        <!--                        <img src="@/assets/images/share/mj.png" alt="">-->
        <!--                        <span>{{ objPoster.house_area }}㎡</span>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--                <div class="qr-wrap">-->
        <!--                    <div class="qr-left">-->
        <!--                        <div class="top-qr">-->
        <!--                            <div class="name">{{ objPoster.nickname }}</div>-->
        <!--                            <div class="tag">高级服务顾问</div>-->
        <!--                        </div>-->
        <!--                        <div class="b-qr">-->
        <!--                            <div>长按识别，了解</div>-->
        <!--                            <div>用户真实使用体验</div>-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                    <div class="qr-right" id="qr-right" ref="qrcode"></div>-->

        <!--                    <div class="qr-head">-->
        <!--                        <img :src="objPoster.headimgurl" alt="">-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--                <div class="b-bg">-->
        <!--                    <div class="logo-img">-->
        <!--                        <img src="@/assets/images/share/logo2.png" alt="">-->
        <!--                        <span>AI-LiNK好风好水智慧集成</span>-->
        <!--                    </div>-->
        <!--                    <div class="sp">-->
        <!--                        <img src="@/assets/images/share/sp3.png" alt="">-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--            <div v-if="sBase64" class="poster-content-img-wrap">-->
        <!--                <div class="poster-content-img">-->
        <!--                    <img :src="sBase64" alt="">-->
        <!--                    <img class="close" @click="closePoster" src="@/assets/images/share/close_icon.png" alt="">-->
        <!--                    <div class="tips-save">*长按保存图片<br/>*朋友圈文字已复制</div>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </div>-->
        <div class="poster" :style="{background:!sBase64?'none':'rgba(0,0,0,0.6)'}" v-if="isShowPoster">
            <div class="poster-content" ref="canvas" id="capture">
                <div class="top-title">
                    <div class="text">{{ objPoster.poster_title || '“很满意史密斯这次的服务，采暖、 空调效果也非常好”' }}</div>
                    <div class="name">—— {{ objPoster.city }}用户 {{ objPoster.name }}</div>
                </div>
                <div class="poster-bgc">
                    <img v-if="objPoster.poster_pic" :src="objPoster.poster_pic" alt="">
                    <img v-else src="@/assets/images/share/top-bgc.png" alt="">
                </div>
                <div class="title">{{ objPoster.city }} ｜ {{ objPoster.project_name2 }}</div>
                <div class="info">
                    <div class="info-item">
                        <img src="@/assets/images/share/rl.png" alt="">
                        <span>{{ objPoster.date.split(' ')[0] }}</span>
                    </div>
                    <div v-if="objPoster.house_cate" class="info-item">
                        <img src="@/assets/images/share/bs.png" alt="">
                        <span>{{ objPoster.house_cate }}</span>
                    </div>
                    <div v-if="objPoster.house_area" class="info-item">
                        <img src="@/assets/images/share/mj.png" alt="">
                        <span>{{ objPoster.house_area }}㎡</span>
                    </div>
                </div>
                <div class="qr-wrap">
                    <div class="qr-left">
                        <div class="top-qr">
                            <div class="name">{{ objPoster.nickname }}</div>
                            <div class="tag">高级服务顾问</div>
                        </div>
                        <div class="b-qr">
                            <div>长按识别，了解</div>
                            <div>用户真实使用体验</div>
                        </div>
                    </div>
                    <div class="qr-right" id="qr-right" ref="qrcode"></div>

                    <div class="qr-head">
                        <img :src="objPoster.headimgurl" alt="">
                    </div>
                </div>
                <div class="b-bg">
                    <div class="logo-img">
                        <img src="@/assets/images/share/logo2.png" alt="">
                        <span>AI-LiNK好风好水智慧集成</span>
                    </div>
                    <div class="sp">
                        <img src="@/assets/images/share/sp3.png" alt="">
                    </div>
                </div>
            </div>

            <div v-if="sBase64" class="poster-content-img-wrap">
                <div class="poster-content-img">
                    <img :src="sBase64" alt="">
                    <img class="close" @click="closePoster" src="@/assets/images/share/close_icon.png" alt="">
                    <div class="tips-save">*长按保存图片<br/>*朋友圈文字已复制</div>
                </div>
            </div>
        </div>
        <!-- 视频图片轮播 -->
        <div class="swipe-box" v-if="imgShow">
            <van-swipe @change="swipeChaneg" :initial-swipe="nChangeIndex">
                <van-swipe-item v-for="(item, index) in arrStausImg" :key="index">
                    <div class="swipe-image" v-if="item.type == 'image'"><img
                        :src="item.pic + '?x-oss-process=image/resize,w_800'"/></div>
                    <div v-if="item.type == 'video'" class="meng-img">
                        <video id="videoUrl" controls
                               :poster="item.pic+ '?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,ar_auto'"
                               :src="item.pic"/>
                        <!-- <video id="videoUrl" :src="item.pic" />
                        <div class="video-img" id="video-img">
                            <img :src="item.pic + '?x-oss-process=video/snapshot,t_1000,m_fast'"/>
                        </div>
                        <div id="mantle" class="video_mantle" @click="playVideo2">
                            <img :src="require('@/assets/images/icon_play.png')" />
                        </div> -->
                    </div>
                </van-swipe-item>
            </van-swipe>
            <div class="directive">{{ nChangeIndex + 1 }}/{{ arrStausImg.length }}</div>
            <div class="swipe-close" @click="imgShow = false">
                <img :src="require('@/assets/images/antV2/icon_close.png')"/>
            </div>
        </div>
        <!-- <van-image-preview v-model="imgShow" :closeable="true" :startPosition="lookImgIndex" :images="arrStausImg"></van-image-preview> -->
        <!-- 分享弹框 -->
        <div class="share-popup" v-if="isShowSharePopup" @click.stop="isShowSharePopup = false">
            <div class="share-content" @click.stop>
                <div class="share-title">请选择分享方式</div>
                <div class="share-wrap">
                    <div class="share-item" @click="toPoster">
                        <img src="@/assets/images/share/poster.png" alt="">
                        <span>生成海报</span>
                    </div>
                    <!--                    <div class="share-item" @click="toCopy">-->
                    <!--                        <img src="@/assets/images/share/ljp.png" alt="">-->
                    <!--                        <span>分享链接</span>-->
                    <!--                    </div>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import {getEvaPoster, shareNum} from '@/js/project/share.js'
// import html2canvas from "html2canvas";
import html2canvas from "@/libsV2/html2canvas";
import elStare from '@/components/stares/stares'
import elAgree from "@/components/agree/index";
import oDetail from "@/js/detail";

import {
    Toast
} from "mint-ui";
import {
    getProjectList, v2tov3id
} from "@/js/project/evaluation.js"

export default {
    components: {
        elStare,
    },
    beforeMount() {

    },
    data() {
        return {
            objShareInfo: {},//分享的评价
            sBase64: '',
            objPoster: {},//海报信息
            isShowPoster: false,//海报
            share_link: '',//分享链接
            isShowSharePopup: false,
            sTitle: '',
            arrAllLabel: [{
                title: '全部',
                num: '1'
            }, {
                title: '有图/视频',
                num: '1'
            }, {
                title: '追评',
                num: '1'
            }],
            loading: false,
            finished: false,
            nLabel: 0,
            nSort: true,
            arrAssLabel: [],
            arrList: [],
            numScore: 3.7,
            indexSort: 'id',
            indexType: 'all',
            isBoxHeight: false,
            isShowIcon: true,
            isSore: false,
            audioUrl: '',
            nTabel: '-1',
            nPage: 0,
            arrIndex: 0,
            changeIndex: 1,
            labelTitle: '',
            isScoll: true,
            isMentShow: false,
            isType: '',
            nMentUrl: '',
            imgShow: false,
            lookImgIndex: 0,
            arrStausImg: [],
            nChangeIndex: 0,
            isZxy: false
        }
    },
    created() {

        $init(() => {
            oDetail.getAuthorZxy().then((res) => {
                this.isZxy = res.result;
            });
            // wx.miniProgram.postMessage({ data: {foo: 'bar'} })
            this.acc_id = this.$route.query.acc_id
            this.nTabel = this.$route.query.label
            this.sTitle = this.$route.query.title
            this.getListData()
            if (this.$route.query.project_uuid && !this.tCensus) {
                this.addReadNum(this.$route.query.project_uuid, 'more_discuss', 'anli_more').then(result => {
                    this.tCensus = setInterval(() => {
                        console.log('统计数据---更多评价')
                        // this.$toast('统计')
                        this.addReadNum(this.$route.query.project_uuid, 'more_discuss', 'anli_more', result)
                    }, 5000)
                })
            }
        })
    },
    computed: {
        arrShowList() {
            if (!this.sTitle) {
                return this.arrList
            } else {
                return this.arrList.filter(it => {
                    if (it.tags != undefined) {
                        return it.tags.findIndex(item => item == this.sTitle) != -1
                    }
                })
            }
        }
    },
    mounted() {
        let height = this.$refs.lableHight;
        let a = window.getComputedStyle(height).height
        console.log(height, a);
    },
    methods: {

        // 关闭海报
        closePoster() {
            this.sBase64 = ''
            this.isShowPoster = false
        },
        // 获取海报基本信息
        getBaseInfo(project_uuid) {
            let that = this
            getEvaPoster({
                project_uuid: project_uuid,
            }).then(res => {
                if (typeof (res.data.result) != 'string') {
                    this.objPoster = res.data.result
                    this.isShowPoster = true
                    this.$store.commit("loadSwitch", true);
                    setTimeout(() => {
                        let qr = new QRCode(that.$refs.qrcode, {
                            // text 需要转二维码的内容 可以是文本也可以是一个链接 是链接会直接跳走
                            text: that.share_link,
                            width: 148,
                            height: 148,
                            colorDark: '#333',//二维码颜色
                            colorLight: '#fff',//二维码背景颜色
                            correctLevel: QRCode.CorrectLevel.L//容错率,L/M/H
                        })
                        setTimeout(() => {
                            that.getShareImgBase64()
                        }, 500)
                    }, 500)
                } else {
                    this.$toast(res.data.result)
                    this.$store.commit("loadSwitch", false);
                }
                console.log(res, '信息')
            }).catch(err => {
                this.$toast('请求失败')
                this.$store.commit("loadSwitch", false);
                console.log(err, '信息2')
            })
        },
        // 海报
        toPoster() {
            this.toCopy('1')
            this.isShowSharePopup = false
            this.getBaseInfo(this.objShareInfo.children[0].project_uuid)
        },
        // 复制链接
        toCopy(type) {
            let that = this
            let sTips = ""
            if (type != '1') {
                sTips = "A.O.史密斯AI-LiNK好风好水智慧集成系统真实用户体验，快点击查看吧~"
            } else {
                sTips = "A.O.史密斯AI-LiNK好风好水智慧集成系统真实用户体验，快扫码识别查看吧~"
            }
            //&track_action=share_project&track_id=${this.objShareInfo.children[0].project_uuid}&track_uuid=${sessionStorage.getItem('page_uuid')}
            this.share_link = `${window.location.origin}/project/share/index?project_uuid=${this.objShareInfo.children[0].project_uuid}&share_id=${this.$storage.getStorage('user_id')}&acc_id=${this.acc_id}`
                + `&track_action=project_share_discuss&track_id=${this.objShareInfo.children[0].project_uuid}&track_uuid=${sessionStorage.getItem('page_uuid')}` + `&sfrom=${this.$route.query.ut_source}&from_id=${this.$storage.getStorage("user_id")}`;
            console.log(this.share_link, 'share_link')
            // 创建模拟 输入框
            var cInput = document.createElement("input");
            // cInput.value = sTips+this.share_link;
            console.log(this.share_link)
            cInput.value = sTips;
            document.body.appendChild(cInput);
            cInput.select(); // 选取文本框内容
            // 执行浏览器复制命令
            // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
            // Input要在正常的编辑状态下原生复制方法才会生效
            document.execCommand("copy");
            // 复制成功后再将构造的标签 移除
            document.body.removeChild(cInput);
            if (type != '1') {
                this.$toast('复制成功')
                this.isShowSharePopup = false
            }

        },
        // 点击分享
        toShare(item) {
            this.isShowSharePopup = true
            this.objShareInfo = item
            console.log(item)
        },
        // 获取分享图片 base64
        getShareImgBase64() {
            let that = this
            let sHeight = that.$refs.canvas.offsetHeight;
            let sWidth = that.$refs.canvas.offsetWidth;
            console.log(sHeight, sWidth, '截图高度')
            setTimeout(() => {
                // #capture 就是我们要获取截图对应的 DOM 元素选择器
                html2canvas(that.$refs.canvas, {
                    allowTaint: true, // 允许跨域图片
                    useCORS: true,
                    height: sHeight,
                    width: sWidth,
                    x: 0,
                    y: 2 * window.innerHeight,
                    scrollX: 0,
                    scrollY: 0,
                    dpi: window.devicePixelRatio,
                    scale: 2,
                }).then((canvas) => {
                    that.isShowSharePopup = false
                    const imgData = canvas.toDataURL("image/png");
                    that.sBase64 = imgData
                    that.$store.commit("loadSwitch", false);
                    that.$common.pushEvent('project_share_discuss', that.objShareInfo[0].project_uuid);
                    // 统计转发数据
                    // shareNum({
                    //     project_uuid:this.$route.query.acc_id,
                    //     sfrom:this.$route.query.ut_source,
                    //     from_id:this.$storage.getStorage("user_id"),
                    // }).then()
                    console.log(imgData)
                }).catch(err => {
                    console.log(err, '截图失败')
                });
            }, 500); // 这里加上 300ms 的延迟是为了让 DOM 元素完全渲染完成后再进行图片的生成
        },
        //获取时间差
        computTime(oldTime) {
            if (oldTime == null && oldTime == undefined) {
                return '1天'
            }
            let nowTime = new Date().getTime();  //现在时间 时间戳
            let endTime = oldTime.replace(/-/g, '/');
            let zhuiTime = new Date(endTime);
            zhuiTime = zhuiTime.getTime();
            let diffTime = (nowTime - zhuiTime) / 1000
            let timeData = ''

            if (diffTime < 0) {
                timeData = '1天'
            } else if (0 < diffTime && diffTime < 86400) {
                timeData = '1天'
            } else if (86400 < diffTime && diffTime < 2592000) {
                timeData = parseInt(diffTime / 86400) + '天'
            } else if (2592000 < diffTime && diffTime < 31536000) {
                timeData = parseInt(diffTime / 2592000) + '个月'
            } else {
                timeData = parseInt(diffTime / 31536000) + '年'
            }

            return timeData
        },
        nameHide(name) {
            if (name.length <= 1) {
                name
            } else if (1 <= name.length && name.length <= 2) {
                name = name[0] + '*'
            } else if (3 <= name.length) {
                name = name[0] + '***' + name[name.length - 1]
            }
            return name
        },
        swipeChaneg(e) {
            this.nChangeIndex = e
        },
        getShow(e, num) {
            let arr = []
            e.forEach(it => {
                arr.push({
                    pic: it.pic,
                    type: it.type
                })
            })
            this.nChangeIndex = num;
            this.imgShow = true;
            this.arrStausImg = arr;
        },
        playVideo2() {
            let video = document.getElementById('videoUrl');
            console.log(video);
            if (video.paused) {
                video.play();
                document.getElementById('mantle').style.display = 'none'
                document.getElementById('video-img').style.display = 'none'
            } else {
                video.pause();
                document.getElementById('mantle').style.display = 'block'
                document.getElementById('video-img').style.display = 'block'
            }
            video.addEventListener('ended', function () {
                document.getElementById('mantle').style.display = 'block'
                document.getElementById('video-img').style.display = 'block'
            });
        },
        //获取列表数据
        getListData() {
            this.$store.commit("loadSwitch", true);
            getProjectList({
                page: 0,
                limit: 10000,
                project_uuid: this.acc_id,
                type: this.indexType,
                sort: this.indexSort,
                sort_type: 'desc',
            }).then(res => {
                console.log(res, '列表数据');
                // this.loading = false;
                if (res.data.result.length == 0) {
                    this.isScoll = false
                    this.finished = true;
                }
                this.arrAllLabel[0].num = res.data.result.total_num
                this.arrAllLabel[1].num = res.data.result.pic_num
                this.arrAllLabel[2].num = res.data.result.zhui_num


                let arr = []
                res.data.result.lists.forEach((it, ix) => {
                    // this.arrMent.lists.forEach((it, ix) => {
                    let obj = {}
                    obj.tags = []
                    obj.children = []
                    if (ix == 0) {
                        obj.open = true
                    } else {
                        obj.open = false
                    }

                    it.forEach(ixx => {

                        if (ixx.tags) {
                            obj.tags = ixx.tags_name
                        }
                        // ixx.tags_name.forEach(im => {
                        //     obj.tags.push(im)
                        // })

                        if (ixx.is_completed == 3) {
                            obj.children.push({...ixx, open: true})
                        } else {
                            obj.children.push({...ixx, open: false})
                        }
                        if (ixx.content2 != '' && ixx.content2 != null) {
                            let zuipingObj = {
                                content: ixx.content2,
                                pic: ixx.pic_zhui,
                                created_at: ixx.zhui_time,
                                voice: '',
                                is_completed: '追评',
                                score: '',
                            }
                            obj.children.push({
                                ...zuipingObj,
                                open: true
                            })
                        }
                    })
                    arr.push(obj)
                })
                arr.forEach((it, ik) => {
                    if (it.children.length < 3) {
                        let arrzui = it.children.filter(ix => {
                            return ix.is_completed == '追评'
                        });
                        let arr3 = it.children.filter(ix => {
                            return ix.is_completed == 3
                        });
                        let arr2 = it.children.filter(ix => {
                            return ix.is_completed == 2
                        });
                        let arr1 = it.children.filter(ix => {
                            return ix.is_completed == 1
                        });
                        if (arrzui.length) {
                            it.children.forEach(ix => {
                                if (ix.is_completed != '追评') {
                                    ix.open = false
                                } else {
                                    ix.open = true
                                }
                            })
                        } else if (arr3.length) {
                            it.children.forEach(ix => {
                                if (ix.is_completed != 3) {
                                    ix.open = false
                                } else {
                                    ix.open = true
                                }
                            })
                        } else if (arr1.length) {
                            it.children.forEach(ix => {
                                if (ix.is_completed != 1) {
                                    ix.open = false
                                } else {
                                    ix.open = true
                                }
                            })
                        } else if (arr2.length) {
                            it.children.forEach(ix => {
                                if (ix.is_completed != 2) {
                                    ix.open = false
                                } else {
                                    ix.open = true
                                }
                            })
                        }
                    } else {
                        it.children.forEach(ix => {
                            if (ix.is_completed != '追评') {
                                ix.open = false
                            } else {
                                ix.open = true
                            }
                        })
                    }
                    if (ik == 0) {
                        it.children.forEach((ix, im) => {
                            ix.open = true
                        })
                    }
                })
                console.log(arr, '数组');
                this.arrList = arr


                //标签
                this.arrAssLabel = res.data.result.tags
                if (this.arrAssLabel.length > 6) {
                    this.isBoxHeight = true
                } else {
                    this.isBoxHeight = false
                    // this.isShowIcon = false
                }
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.$store.commit("loadSwitch", false);
                    }, 200)
                })
            })
        },
        //判断是否有这个值 没有则返回-1
        findElem(array, attr, val) {
            for (var i = 0; i < array.length; i++) {
                if (array[i][attr] == val) {
                    return i; //返回当前索引值
                }
            }
            return -1;
        },
        //音频播放
        handlePlay(index, ix) {
            let id = 'audio' + index + ix
            let idx = 'meng' + index + ix
            let audio = document.getElementById(id)
            let ment = document.getElementById(idx)
            if (audio.paused) {
                audio.play()
                ment.style.display = 'block';
            } else {
                audio.pause()
                ment.style.display = 'none';
            }
            audio.addEventListener('ended', function () {
                audio.style.display = 'block';
                ment.style.display = 'none';
            });
        },
        //视频播放
        // playVideo(url, type) {
        //     this.isMentShow = true
        //     this.isType = type
        //     this.nMentUrl = url
        //     console.log(this.isType);
        //     return
        //     console.log(index);
        //     let id = 'playVideo' + index + ix + ic
        //     let mantle = 'mantle' + index + ix + ic
        //     let video = document.getElementById(id);
        //     console.log(video);
        //     if (video.paused) {
        //         video.play();
        //         document.getElementById(mantle).style.display = 'none'
        //     } else {
        //         video.pause();
        //         document.getElementById(mantle).style.display = 'block'
        //     }
        //     video.addEventListener('ended', function () {
        //         document.getElementById(mantle).style.display = 'block'
        //     });
        // },
        //切换
        changeTaber(index) {
            this.nPage = 0
            this.arrList = []
            this.nLabel = index
            if (index == 0) {
                this.indexType = 'all'
                this.getListData()
            } else if (index == 1) {
                this.indexType = 'pic'
                this.getListData()
            } else if (index == 2) {
                this.indexType = 'zhui'
                this.getListData()
            }
        },
        //切换
        changeSort() {
            this.nPage = 0
            this.arrList = []
            this.nSort = !this.nSort
            if (this.nSort) {
                this.indexSort = 'time'
                this.getListData()
                Toast({
                    message: "切换为默认排序"
                });
            } else {
                this.indexSort = 'id'
                this.getListData()
                Toast({
                    message: "切换为时间排序"
                });
            }
        },
        //点击标签
        antLabel(index, title) {
            if (this.nTabel == index) {
                this.nTabel = '-1'
                this.sTitle = ''
            } else {
                this.nTabel = index
                this.sTitle = title
            }
            // console.log(title, 'title');
            // return
            // this.arrList = this.arrList.filter(it => {
            //     if (it.tags.findIndex(item => item == title) != -1) {
            //         return true
            //     } else {
            //         return false
            //     }
            // })
            // console.log(this.arrList, 'this.arrList')
            // this.labelTitle = title
        },
        changeMore(type, arr, open) {
            // console.log(open);
            if (type == 'more') {
                arr.forEach(it => {
                    if (!it.open) {
                        it.open = true
                    }
                })
                open.open = true
            } else {
                open.children.forEach(it => {
                    if (open.children.length == 3) {
                        if (it.is_completed != '追评') {
                            it.open = false
                        }
                    } else {
                        console.log(it, '22222');
                        console.log(this.findElem(open.children, 'is_completed', '3'), '====');
                        // 没有3则返回-1,
                        // 有3 true 没有 false
                        if (this.findElem(open.children, 'is_completed', '追评') != -1) {
                            if (it.is_completed != '追评') {
                                it.open = false
                            }
                        } else if (this.findElem(open.children, 'is_completed', '3') != -1) {
                            if (it.is_completed != 3) {
                                it.open = false
                            }
                        } else if (this.findElem(open.children, 'is_completed', 1) != -1) {
                            if (it.is_completed != 1) {
                                it.open = false
                            }
                        } else if (this.findElem(open.children, 'is_completed', '2') != -1) {
                            if (it.is_completed != 2) {
                                it.open = false
                            }
                        }
                    }
                })
                open.open = false
            }
        },
        //触底
        chengeLoad() {
            // if (this.nPage < 2) {
            //     this.loading = true;
            //     this.nPage++
            //     this.getListData()
            // }
        }
    }
}
</script>
<style>
#qr-right > img {
    width: 100% !important;
    height: 100% !important;
}

#qr-right > canvas {
    width: 100% !important;
    height: 100% !important;
}
</style>
<style scoped lang="scss">
.share-popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    z-index: 8;

    .share-content {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 264px;
        background: #FFFFFF;
        border-radius: 24px 24px 0px 0px;
        padding: 20px 60px;

        .share-title {
            text-align: center;
            font-size: 28px;
            font-weight: 400;
            color: #328444;
            line-height: 40px;
        }

        .share-wrap {
            display: flex;
            align-items: center;
            margin-top: 30px;

            .share-item {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                img {
                    width: 80px;
                    height: 80px;
                    margin-bottom: 8px;
                }

                span {
                    font-size: 24px;
                    font-weight: 400;
                    color: #808080;
                    line-height: 34px;
                }
            }
        }
    }
}

.swipe-box {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);

    .swipe-close {
        position: absolute;
        top: 28px;
        right: 28px;

        img {
            width: 38px;
            height: 38px;
        }
    }

    .directive {
        position: absolute;
        top: 28px;
        left: 50%;
        // z-index: 1200;
        transform: translate(-50%);
        color: #fff;
        font-size: 28px;
        padding: 4px 18px;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 2px;
    }

    .swipe-image {
        position: relative;
        // position: absolute;
        width: 100vw;
        height: 100vh;

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    .meng-img {
        position: relative;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;

        video {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

        .video-img {
            position: absolute;
            left: 0;
            top: 0;
            z-index: 1;

            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }

        .video_mantle {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 50%;
            top: 0;
            z-index: 2;
            transform: translate(-50%);
            background: rgba(0, 0, 0, 0.5);
            border-radius: 10px;

            img {
                position: absolute;
                top: calc(50% - 39px);
                left: calc(50% - 39px);
                width: 78px;
                height: 78px;
            }
        }
    }
}

.poster {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    z-index: 8;

    .poster-content {
        width: 564px;
        height: fit-content;
        background: #fff;
        position: absolute;
        top: 200vh;
        left: 0;
        margin: 0 auto;
        z-index: 1;
        // border-radius: 24px;
        overflow: hidden;

        .top-title {
            padding: 28px 28px 28px 38px;
            // background: linear-gradient(180deg, #1D4B9A 0%, #102960 100%);
            background: #1D4B9A;
            // border-radius: 16px 16px 0 0;
            width: calc(100% + 10px);
            transform: translateX(-10px);

            .text {
                font-size: 32px;
                font-weight: 600;
                color: #FFFFFF;
                line-height: 44px;
            }

            .name {
                font-size: 24px;
                font-weight: 400;
                color: rgba(255, 255, 255, 0.6);
                line-height: 28px;
                text-align: right;
            }
        }

        .poster-bgc {
            width: 100%;
            height: 310px;
            display: flex;
            align-items: center;
            justify-content: center;
            object-fit: cover;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .title {
            font-size: 28px;
            font-weight: 400;
            color: #222222;
            line-height: 40px;
            margin-top: 24px;
            padding: 0 28px;
        }

        .info {
            margin-top: 8px;
            display: flex;
            align-items: center;
            padding: 0 28px;

            .info-item {
                display: flex;
                align-items: center;
                margin-right: 32px;

                img {
                    width: 24px;
                    height: 24px;
                    margin-right: 8px;
                }

                span {
                    font-size: 24px;
                    font-weight: 400;
                    color: #AEAEAE;

                }
            }
        }

        .qr-wrap {
            width: 488px;
            height: 172px;
            background: #EBF0F7;
            border-radius: 12px;
            margin: 48px 20px 0 auto;
            padding: 0 16px 0 44px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;

            .qr-left {
                flex: 1;

                .top-qr {
                    display: flex;
                    align-items: center;

                    .name {
                        font-size: 20px;
                        font-weight: 400;
                        color: #666666;
                    }

                    .tag {
                        margin-left: 12px;
                        font-size: 20px;
                        font-weight: 400;
                        color: #AEAEAE;
                    }
                }

                .b-qr {
                    margin-top: 22px;
                    font-size: 28px;
                    font-weight: 600;
                    color: #222222;
                    line-height: 40px;
                }
            }

            .qr-right {
                width: 148px;
                height: 148px;
                background: #ffffff;
                // border-radius: 50%;
                img {
                    width: 100% !important;
                    height: 100% !important;
                }

                canvas {
                    width: 100% !important;
                    height: 100% !important;
                }
            }

            .qr-head {
                width: 56px;
                height: 56px;
                border-radius: 50%;
                position: absolute;
                top: 12px;
                left: -28px;
                background: #102960;
                object-fit: cover;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 50%;
                }
            }
        }

        .b-bg {
            width: 100%;
            height: 124px;
            background: #F7F7F7;
            margin-top: 68px;
            padding: 20px 20px 0 28px;
            display: flex;
            justify-content: space-between;

            .logo-img {
                display: flex;
                flex-direction: column;
                white-space: nowrap;
                align-items: center;
                width: 272px;

                img {
                    width: 272px;
                    height: 32px;
                }

                span {
                    font-size: 24px;
                    display: inline-block;
                    text-align: justify;
                    white-space: nowrap;
                    font-weight: 400;
                    color: #004097;
                    line-height: 32px;
                    margin-top: 8px;
                }
            }

            .sp {
                img {
                    width: 202px;
                    height: 120px;
                    transform: translateY(-50px);
                }
            }
        }
    }

    .poster-content-img-wrap {
        width: 564px;
        height: 95vh;
        border-radius: 24px 24px 0 0;
        overflow-y: scroll;
        position: absolute;
        left: 50%;
        top: 5%;
        transform: translate(-50%, 0);
        padding-bottom: 40px;
        box-sizing: border-box;
    }

    .poster-content-img-wrap {
        width: 564px;
        height: 95vh;
        border-radius: 24px 24px 0 0;
        overflow-y: scroll;
        position: absolute;
        left: 50%;
        top: 5%;
        transform: translate(-50%, 0);
        padding-bottom: 40px;
        box-sizing: border-box;
    }

    .poster-content-img {
        width: 100%;
        height: fit-content;
        margin: 0 auto;
        position: relative;

        img {
            width: 100%;
            border-radius: 24px;
        }

        .close {
            width: 68px;
            height: 68px;
            position: absolute;
            bottom: -90px;
            left: 50%;
            transform: translateX(-50%);
        }

        .tips-save {
            position: absolute;
            bottom: -160px;
            left: 50%;
            transform: translateX(-50%);
            color: #f7f7f7;
            letter-spacing: 4px;
            text-align: center;
        }
    }
}

.assess-all {
    .list-height {
        height: 100vh;

        .chioce-box {
            padding: 26px 24px 28px 24px;

            .chioce-nei {
                position: relative;
                width: 100%;
                // height: 316px;
                height: fit-content;
                overflow: hidden;
                background: #FFFFFF;
                box-shadow: 0px 0px 12px 0px rgba(98, 123, 241, 0.34);
                padding: 32px 26px 0px 32px;
                box-sizing: border-box;
                height: 316px;

                border-radius: 16px;

                .top-box {
                    display: flex;
                    justify-content: space-between;

                    img {
                        width: 40px;
                        height: 40px;
                    }

                    .label-css {
                        margin-right: 38px;
                        font-size: 28px;
                        color: #627BF1;
                    }

                    .label-item {
                        margin-right: 38px;
                        font-size: 28px;
                        color: #222222;

                        span {
                            margin-top: 2px;
                            color: rgba(162, 162, 162, 1);
                        }
                    }

                    .sort-css {
                        font-size: 22px;
                        color: rgba(144, 144, 144, 1);
                        display: flex;
                        align-self: center;

                        span {
                            margin-right: 12px;
                        }

                        img {
                            width: 32px;
                            height: 32px;
                        }
                    }
                }

                .lable-box {
                    display: flex;
                    flex-wrap: wrap;
                    height: fit-content;

                    .lable-item {
                        padding: 12px 24px;
                        // background: #EAF1EF;
                        background: rgba(98, 123, 241, 0.1);
                        border-radius: 28px;
                        font-size: 28px;
                        // color: #739E82;
                        color: #627BF1;
                        margin-right: 16px;
                        margin-top: 24px;
                        // box-sizing: border-box;
                    }

                    .lable-index {
                        padding: 12px 24px;
                        // background: #318544;
                        background: rgba(98, 123, 241, 1);
                        border-radius: 28px;
                        font-size: 28px;
                        color: #FFFFFF;
                        margin-right: 16px;
                        margin-top: 24px;
                    }
                }

                .down_icon {

                    bottom: 0;
                    width: calc(100% - 58px);
                    height: 74px;
                    padding-top: 22px;
                    list-style: 74px;
                    background: #fff;
                    text-align: center;
                    box-sizing: border-box;
                    z-index: 2;

                    .down {
                        width: 28px;
                        height: 28px;
                    }

                    .top {
                        transform: rotate(180deg);
                        width: 28px;
                        height: 28px;
                    }
                }
            }
        }

        .user-assess {
            padding: 0px 24px 28px 24px;

            .assess-box {
                margin-bottom: 28px;
                background: #FFFFFF;
                box-shadow: 0px 0px 12px 0px rgba(98, 123, 241, 0.34);
                border-radius: 16px;
                padding: 32px 22px 28px 28px;

                .user-info {
                    display: flex;
                    justify-content: space-between;

                    .user-left-box {
                        display: flex;

                        .head-img {
                            img {
                                width: 80px;
                                height: 80px;
                                border-radius: 50%;
                            }
                        }

                        .user-name {
                            margin-left: 16px;

                            .current-name {
                                display: flex;

                                .name {
                                    font-size: 28rpx;
                                    font-weight: 600;
                                    color: #444444;
                                }

                                .current {
                                    padding: 2px 22px;
                                    margin-left: 28px;
                                    background: rgba(98, 123, 241, 0.1);
                                    font-size: 24px;
                                    font-weight: 400;
                                    color: #627BF1;
                                    border-radius: 20px;
                                }
                            }

                            .name {
                                font-size: 28rpx;
                                font-weight: 600;
                                color: #444444;
                            }

                            .time {
                                margin-top: 12px;
                                font-size: 24px;
                                color: #C2C2C2;
                            }
                        }
                    }

                    .user-right-box {
                        // width: 112px;
                        height: 52px;
                        padding: 10px 8px 10px 20px;
                        box-sizing: border-box;
                        border-radius: 26px 0 0 26px;
                        font-size: 24px;
                        background: rgba(255, 179, 3, 0.1);
                        color: #EFA104;
                        margin-right: -22px;

                        img {
                            width: 32px;
                            height: 32px;
                            margin-right: 6px;
                        }
                    }
                }

                .stars-title {
                    font-size: 28px;
                    margin-right: 24px;
                    font-weight: 600;
                    color: #627BF1;
                }

                .assess-stars {
                    margin-top: 22px;
                    display: flex;

                    .stars-title {
                        font-size: 28px;
                        margin-right: 24px;
                        font-weight: 600;
                        color: #627BF1;
                    }

                    .stars-box {
                        width: 230px;
                        position: relative;

                        .stars-hig-box {
                            position: absolute;
                            display: flex;
                            z-index: 5;

                            .stars-hig {
                                position: relative;

                                .stars-img {
                                    margin-right: 12px;
                                    width: 32px;
                                    height: 32px;
                                }

                                .stars-img-item {
                                    position: absolute;
                                    margin-right: 12px;
                                    width: 32px;
                                    height: 32px;
                                    clip: rect(0px, var(--percen), 32px, 0px);
                                    // clip:rect(0px , 19px , 32px , 0px);
                                }
                            }
                        }

                        .stars-ash-box {
                            position: absolute;
                            display: flex;
                            z-index: 4;

                            .stars-ash {
                                img {
                                    margin-right: 12px;
                                    width: 32px;
                                    height: 32px;
                                }
                            }
                        }
                    }
                }

                .assess-content {
                    margin-top: 8px;
                    font-size: 28px;
                    color: #444444;
                }

                .assess-voice {
                    margin-top: 18px;
                    position: relative;
                    right: -20px;
                    top: 0;
                    width: 514px;
                    height: 64px;
                    // background: #F7F7F7;
                    background: rgba(98, 123, 241, 0.1);
                    border-radius: 10px;
                    font-size: 28px;
                    // color: #6C9276;
                    border: 2px solid rgba(98, 123, 241, 0.5);
                    color: #627BF1;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;

                    .voice-icon {
                        margin: 0 26px 0 16px;
                        position: relative;
                        width: 32px;
                        height: 32px;

                        img {
                            width: 32px;
                            height: 32px;
                        }

                        .icon1 {
                            position: absolute;
                            left: 50%;
                            transform: translate(-50%);
                            top: 0;
                            width: 8px;
                            height: 32px;
                            z-index: 2;
                        }

                        .mengceng {
                            position: absolute;
                            left: 50%;
                            transform: translate(-50%);
                            top: 0;
                            width: 8px;
                            height: 32px;
                            background: #F7F7F7;
                            z-index: 1;
                            animation: title 2s infinite;
                        }

                        @keyframes title {
                            0% {
                                width: 8px;
                            }

                            40% {
                                width: 30px;
                            }

                            50% {
                                width: 32px;
                            }

                            90% {
                                width: 10px;
                            }

                            100% {
                                width: 8px;
                            }
                        }
                    }

                    .triangle-icon {
                        position: absolute;
                        width: 0;
                        height: 0;
                        border-top: 10px solid transparent;
                        border-right: 22px solid rgba(98, 123, 241, 0.50);
                        border-bottom: 10px solid transparent;
                        top: 20px;
                        left: -22px;

                        .triangle-one {
                            position: absolute;
                            width: 0;
                            height: 0;
                            border-top: 8px solid transparent;
                            border-right: 20px solid rgba(239, 241, 253, 1);
                            border-bottom: 8px solid transparent;
                            top: -7px;
                            left: 2px;
                            z-index: 2;
                        }
                    }
                }

                .assess-imgae {
                    width: 100%;
                    // height: 198px;
                    display: flex;
                    flex-wrap: wrap;

                    // justify-content: space-between;
                    .assess-imgae-item {
                        position: relative;
                        margin-left: 10px;
                        margin-top: 28px;

                        img {
                            width: 198px;
                            height: 198px;
                            border-radius: 10px;
                            object-fit: cover;
                        }

                        video {
                            width: 198px;
                            height: 198px;
                            border-radius: 10px;
                        }

                        .video_mantle {
                            position: absolute;
                            width: 100%;
                            height: 100%;
                            left: 0;
                            top: 0;
                            background: rgba(0, 0, 0, 0.5);
                            border-radius: 10px;

                            img {
                                position: absolute;
                                top: calc(104px - 39px);
                                left: calc(104px - 39px);
                                width: 78px;
                                height: 78px;
                            }
                        }
                    }
                }

                .split-line {
                    margin-top: 40px;
                    border: 2px dashed #E5E5E5;
                }

                .look-more {
                    margin-top: 38px;
                    text-align: center;
                    font-size: 24px;
                    color: #627BF1;

                    img {
                        margin: 1px 0 0 4px;
                        width: 28px;
                        height: 28px;
                    }
                }

                .look-more-item {
                    margin-top: 38px;
                    text-align: center;
                    font-size: 24px;
                    color: #627BF1;

                    img {
                        transform: rotate(180deg);
                        margin: 1px 0 0 4px;
                        width: 28px;
                        height: 28px;
                    }
                }
            }
        }
    }
}
</style>
